import React from 'react';
import Heading from './components/Heading/Heading';
import FirmwareControlPanel from './components/FirmwareControlPanel/FirmwareControlPanel';
import Firmwares from './components/Firmwares/Firmwares';
import PaginationComponent from './components/PaginationComponent/PaginationComponent';
import style from './FirmwareSection.module.scss';

const FirmwareSection: React.FC = () => {
	return (
		<div className={style.container} data-test="FirmwareSection">
			<div className={style.wrapper}>
				<Heading />
				<FirmwareControlPanel />
				<Firmwares />
				<PaginationComponent />
			</div>
		</div>
	);
};

export default FirmwareSection;
